import { serialize } from '../../../BufferEditor'
import type { BufferEditor } from '../../../BufferEditor/types.plate'
import { LinkedInAnnotationInputElement } from '../nodes'
import type { LinkedInAnnotationEntity } from '../nodes'

function isDBEntry(
  entry: LinkedInAnnotationEntity | undefined,
): entry is LinkedInAnnotationEntity {
  return !!entry
}
// Find all linkedIn annotation elements in the editor
// and returns them in the format they're stored in the db.
// The returned entities are used again when loading the post to re-convert
// the annotation text into linkedIn annotation elements.
export const getAllLinkedInAnnotations = (
  editor: BufferEditor,
): LinkedInAnnotationEntity[] => {
  const nodeEntries = editor.api.nodes<LinkedInAnnotationInputElement>({
    at: [],
    match: (n) => LinkedInAnnotationInputElement.is(n),
  })

  return Array.from(nodeEntries)
    .map(([node, path]): LinkedInAnnotationEntity | undefined => {
      const { autocompleted, valid } = node

      const pointBefore = editor.api.before(path)

      const entity = LinkedInAnnotationInputElement.toEntity(node)

      // Only return valid, autocompleted LinkedIn mentions
      // pointBefore can't be null or undefined, so adding it to condition here
      if (autocompleted && valid && entity && pointBefore) {
        const range = {
          anchor: { path: [0, 0], offset: 0 },
          focus: pointBefore,
        }

        const { text } = serialize(editor, {
          at: range,
        })
        const start = text.length
        // The node itself is void with permanently-empty children, so its
        // displayed length has to come from the resolved entity's own
        // name, not from reading the node's text.
        const { length } = entity.localizedName

        return Object.assign({}, entity, { start, length })
      }

      return undefined
    })
    .filter(isDBEntry)
}
